import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { VngButtonComponent } from "@vengreso/angular-components";
import {
  NotificationSurveyChoice,
  NotificationSurveyContent,
  NotificationTemplate,
} from "src/app/core/models/notification.model";
import { NotificationTemplateRenderer } from "../notification-template-renderer";

/**
 * Renders `{kind: "survey", content: {title, question, choices: [{key,
 * label}], allow_multiple?}}` — a short in-app survey. Submitting emits
 * `respond` with `{ choices: string[] }`, forwarded by
 * `NotificationItemComponent` to `AppNotificationService.respond(id,
 * payload)`.
 */
@Component({
  selector: "app-notification-survey-renderer",
  standalone: true,
  imports: [CommonModule, VngButtonComponent],
  templateUrl: "./notification-survey-renderer.component.html",
  styleUrls: ["../notification-templates.scss"],
})
export class NotificationSurveyRendererComponent implements NotificationTemplateRenderer {
  @Input() template!: NotificationTemplate;
  @Output() respond = new EventEmitter<Record<string, unknown>>();

  selected: Set<string> = new Set();

  private get content(): NotificationSurveyContent {
    return this.template?.content as unknown as NotificationSurveyContent;
  }

  get title(): string {
    return this.content?.title ?? "";
  }

  get question(): string {
    return this.content?.question ?? "";
  }

  get choices(): NotificationSurveyChoice[] {
    return this.content?.choices ?? [];
  }

  get allowMultiple(): boolean {
    return this.content?.allow_multiple === true;
  }

  get canSubmit(): boolean {
    return this.selected.size > 0;
  }

  isSelected(choice: NotificationSurveyChoice): boolean {
    return this.selected.has(choice.key);
  }

  toggle(choice: NotificationSurveyChoice): void {
    if (this.allowMultiple) {
      if (this.selected.has(choice.key)) {
        this.selected.delete(choice.key);
      } else {
        this.selected.add(choice.key);
      }
    } else {
      this.selected = new Set([choice.key]);
    }
  }

  submit(): void {
    if (!this.canSubmit) {
      return;
    }
    this.respond.emit({ choices: Array.from(this.selected) });
  }
}
